import React, { useState, useEffect, useContext } from 'react';
import { Route, Routes, useNavigate, NavLink } from 'react-router-dom';





import { FcBusinessman, FcManager, FcPortraitMode, FcAutomotive, FcInternal, FcShipped, FcDonate, FcKindle } from "react-icons/fc";
import { FaUserPlus, FaDumbbell } from 'react-icons/fa'; 

import { DataContext } from '../init/getData';

import MembershipTransaction from './membership/membershipTransaction';
import VisitTransaction from './visit/visitTransaction';





function MembershipTransactionsTab(props) {

  const { settingData, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('membershipTransaction');

  useEffect(() => {

    navigate('/membershipTab/membershipTransaction');

  }, []);


  return (
    <div className="card" style={{ paddingTop: '0px', userSelect: 'none' }}>

      <div>

          <NavLink to="membershipTransaction" onClick={() => setActiveTab('membershipTransaction')}>
          <div className={`${activeTab === 'membershipTransaction' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '12%' }}>
            <FaUserPlus color='rgb(255, 128, 0)' size={30} />
            <span className="tab-text">New Membership</span>
          </div>
        </NavLink>

        <NavLink to="visitTransaction" onClick={() => setActiveTab('visitTransaction')}>
          <div className={`${activeTab === 'visitTransaction' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '12%' }}>
            <FaDumbbell color='rgb(255, 128, 0)' size={30} />
            <span className="tab-text">New Visit</span>
          </div>
        </NavLink>

      </div>


      <Routes>

  

        <Route path='MembershipTransaction' element={<MembershipTransaction />} />
        <Route path='VisitTransaction' element={<VisitTransaction />} />
   



      </Routes>

    </div>
  );
}

export default MembershipTransactionsTab;
